const styles = {
    container: {
        border: '1px solid black',
        padding: '0.625rem',
        margin: '0.625rem',
        transition: '1s',
        backgroundColor: 'gainsboro',
    },
    innerContainer: {
        display: { xs: 'flex', sm: 'block' },
        flexDirection: 'column',
    },
    divider: {
        mb: {xs: '0.5rem', md: '1rem'}
    },
    button: {
        mr: {xs: 0, sm: '0.5rem'},
        fontSize: '0.625rem',
        marginBottom: { xs: '0.625rem' },
    }
}

export default styles;